import { Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";

export function CheckoutSteps({ current }: { current: number }) {
  const { t } = useTranslation();
  const steps = t("checkout.steps", { returnObjects: true }) as string[];

  return (
    <div className="grid gap-2 rounded-md border border-border bg-card p-3 sm:grid-cols-6">
      {steps.map((step, index) => {
        const done = index < current;
        const active = index === current;
        return (
          <div key={step} className={cn("flex items-center gap-2 rounded-md px-2 py-2 text-xs", active && "bg-primary/10 text-primary")}>
            <span className={cn("flex h-6 w-6 shrink-0 items-center justify-center rounded-full border text-[10px]", done ? "border-success bg-success text-success-foreground" : active ? "border-primary" : "border-border text-muted-foreground")}>
              {done ? <Check className="h-3 w-3" /> : index + 1}
            </span>
            <span className="truncate font-medium">{step}</span>
          </div>
        );
      })}
    </div>
  );
}
